import { defineStore } from "pinia";

export const ComponentsStore = defineStore('componentsStore', {
    state: () => ({
        
        showAddEntry:{
            show: false,
            _date: new Date().toLocaleDateString('en-GB').replace(/\//g, '-'),

        }
            
    
    
    }),
    getters: {

    },
    actions: {
        // eslint-disable-next-line no-unused-vars
       changeAddEntryForm(){
        console.log('asdc')
        this.showAddEntry.show = !this.showAddEntry.show;
        


       },
       addDateToEntry(date){
        this.showAddEntry._date = date;
   

       }
    },



}) 